enum SurveyType {
  FIT_CULTURAL = 'FIT_CULTURAL',
  QUALITATIVE_HAPPINESS = 'QUALITATIVE_HAPPINESS'
}

export default SurveyType;
